import React, {useState, useEffect, Fragment, useContext} from "react";
import Layout from "components/sales/layout/layout";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import FileUpload from "../../../../../components/sales/fileUpload/fileUpload";
import {Button} from "react-bootstrap";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const SaveDealerCase = ({
                            documentUploadUrlPublic,
                            documentUrlDataPublic,
                            addCaseResponse=[],
                            addCaseRequest,
                            match,
                            carBrandResponse = [],
                            carBrandRequest,
                            carModelRequest,
                            carModelResponse =[],
                            carVariantRequest,
                            carVariantResponse =[],
                            bankListRequest,
                            bankListResponse =[],
                            newBankDetailsRequest,
                            newBankDetailsResponse,
                            vehicleDetailsRequest,
                            vehicleDetailsResponse
                                        }) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{
        vehicle_type: 'used_car',
        customer_first_name: '',
        customer_last_name: '',
        customer_mother_name: '',
        mobile_no: '',
        email: '',
        dob: '',
        gender: '',
        employee_type: '',
        vehicle_no: '',
        vehicle_brand: '',
        vehicle_model: '',
        vehicle_variant: '',
        year_of_manufacturing: '',
        active_insurance: '',
        insurance_validate_date: '',
        loan_approved_amount: '',
        loan_required_amount: '',
        bank_name: '',
        car_loan: '',
        rc: '',
        pan_card: '',
        adhaar_card: '',
        salary_slip: '',
        itr: '',
        bank_statement: '',
        insurance_certificate: '',
        entity_type: '',
        meta_data: {
            customer_details: {},
            employee_details: {},
            vehicle_details: {},
            loan_details: {},
            company_details: {},
            applicant_details: {},
            additional_details: {},
        },
        co_applicant: '',
        electricity_bill: '',
        rent_agreement: '',
        business_proof: '',
    }]);
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [additionDocuments, setAdditionDocuments] = useState([{doc:''}])
    const  [manufaturingDate, setManufacturingDate] = useState([])
    const [currentHypo, setCurrentHypo] = useState('')
    const [otherBankName, setBankName]  = useState(true);
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [accountHolder, setAccountHolder] = useState([{account_holder:'', account_no:'', bank_name: '', ifsc_code:'', branch_name: '', other_bank:''}]);
    const [userId, setUserId] = useState()
    const [companyName, setCompanyName] = useState('')
    const [customerBankName, setCustomerBankName] = useState('')
    const [isChargesRequired, setIsChargedRequired] = useState([{
        processing_fees: 'No',
        loan_sursksha: 'No',
        valuation_charge: 'No',
        documentation_charge: 'No',
        stamp_charge: 'No',
        other_charges: 'No',
    }]);
    const [vehicleNo, setVehicleNo] = useState('');

    useEffect(() => {
        (async () => {
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id)
            setIsLoading(true)
            //Determine the Current Year.
            let currentYear = (new Date()).getFullYear();

            //Loop and add the Year values to DropDownList.

            for (var i = 2000; i <= currentYear; i++) {
                if (!manufaturingDate[manufaturingDate.length]) {
                    manufaturingDate[manufaturingDate.length] = {id: i.toString(), name: i.toString()}
                }
            }
            setManufacturingDate(manufaturingDate)
            console.log(manufaturingDate)
            await carBrandRequest()
            await newBankDetailsRequest()
            await bankListRequest()
            setIsLoading(false)
        })()
    }, [])

    const handleInput = (val, index, e, metaDataKey = '', metaIndex = '') => {
        const list = [...inputList]
        if (metaDataKey && metaIndex) {
            list[0]['meta_data'][metaIndex][index] = '';
            list[0]['meta_data'][metaIndex][index] = val
        } else {
            list[0][index] = val
        }

        setInputList(list)
    }

    const handleChargesInput = (key, val) => {
        const list = [...isChargesRequired];
        list[0][key] = val;
        setIsChargedRequired(list);
    }

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0];
        requestParams['lat'] = islatlng?.lat;
        requestParams['long'] = islatlng?.lng;
        requestParams['account_holder'] = accountHolder
        requestParams['account_holder'] = accountHolder
        requestParams['case_type'] = 'Dealer'

        if(requestParams['bank_name'] === 'Other'){
            requestParams['bank_name'] = otherBankName;
        }

        if(!requestParams['mobile_no'] || requestParams['mobile_no'].length > 10 || requestParams['mobile_no'].length < 10){
            toast.warning("Customer mobile no must be in 10 digit");
            return false;
        }

        if(requestParams['meta_data']?.customer_details && requestParams['meta_data']?.customer_details?.bank_name && requestParams['meta_data']?.customer_details?.bank_name === 'Other'){
            requestParams['meta_data']['customer_details']['bank_name'] =  customerBankName;
        }

        if(additionDocuments[0]['doc']){
            requestParams['addition_document'] = additionDocuments;
        }

        if(!requestParams['mobile_no'] || requestParams['mobile_no'].length > 10){
            toast.warning("Mobile no must be in  digit");
            return false;
        }

        if(requestParams['meta_data']['applicant_details']['mobile_no'] && (requestParams['meta_data']['applicant_details']['mobile_no'].length > 10 || requestParams['meta_data']['applicant_details']['mobile_no'].length < 10)){
            toast.warning("Co Applicant mobile no must be in 10 digit");
            return false;
        }

        if(requestParams['meta_data']['company_details']['mobile_no'] && (requestParams['meta_data']['company_details']['mobile_no'].length > 10 || requestParams['meta_data']['company_details']['mobile_no'].length < 10)){
            toast.warning("Company mobile no must be in 10 digit");
            return false;
        }

        requestParams['ucd_id'] = match?.params?.id;
        if (requestParams['lat'] == null || requestParams['long'] == null) {
            toast.error('Please enable your location');
            return false;
        }

        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        // return
        setIsLoading(true);
        await addCaseRequest(requestParams)
        setIsLoading(false);
    }

    const handleAddDocuments = () => {
        setAdditionDocuments([
            ...additionDocuments, {
                doc: ''
            }
        ]);
    }

    const handleRemoveDocuments = (index) => {
        additionDocuments.slice(index, 1);
        setAdditionDocuments(additionDocuments)
    }

    const handleAdditionInput = (val, index) => {
        const list = [...additionDocuments]
        list[index]['doc'] = val
        setAdditionDocuments(list)
    }

    useEffect(() => {
        if (parseInt(addCaseResponse?.status) === 200) {
            toast.success(addCaseResponse?.message);
            setTimeout(() => {
                window.location.href = `${baseUrl}/ucd/list`
            }, 1000)
        } else if (
            addCaseResponse?.status !== 200
        ) {
            toast.warning(addCaseResponse?.message);
        }
    }, [addCaseResponse]);

    const handleFetchModel = async (modelName) => {
        if (modelName) {
            await carModelRequest(modelName);
        }
    }

    const handleFetchVariant = async (modelName) => {
        if (modelName) {
            await carVariantRequest(modelName);
        }
    }

    const handleAddAccountHolder = () => {
        setAccountHolder([
            ...accountHolder, {account_holder:'', account_no:'', bank_name: '', ifsc_code:'', branch_name: '', other_bank: ''}
        ]);
    }

    const handleRemoveAccountHolder = (e, index) => {
        e.preventDefault();
        let list = [...accountHolder];
        list.splice(index, 1);
        setAccountHolder(list);
    };

    const handleAccountHolderInput = (val, key, index) => {
        const list = [...accountHolder]
        list[index][key] = val
        setAccountHolder(list)
    }

    useEffect(() => {
        const re = /^(?!.*\+).+$/;
        if(companyName && !re.test(companyName)){
            toast.warning("Plus sign (+) is not allowed");
            handleInput('', 'company_name', '', 'meta_data', 'company_details')
        }
    }, [companyName]);

    const handleSearch = async (e) => {
        e.preventDefault();
        if(!vehicleNo){
            toast.error("Please enter vehicle no!");
            return ;
        }
        setIsLoading(true);
        await vehicleDetailsRequest(vehicleNo);
        setIsLoading(false);
    }

    useEffect(() => {
        if (parseInt(vehicleDetailsResponse?.status) === 200) {
            if(Object.keys(vehicleDetailsResponse.data).length > 0){
                toast.success(vehicleDetailsResponse?.message);
                setTimeout(async () => {
                    handleInput(vehicleDetailsResponse?.data?.engine, 'engine_no', 'meta_data', 'vehicle_details')
                    handleInput(vehicleDetailsResponse?.data?.chassis, 'chassis_no', 'meta_data', 'vehicle_details')
                    handleInput(vehicleDetailsResponse?.data?.fuel_type, 'fuel_type', 'meta_data', 'vehicle_details')
                    handleInput(vehicleDetailsResponse?.data?.owner_count, 'ownership_series', 'meta_data', 'vehicle_details')
                    handleInput(vehicleDetailsResponse?.data?.brand_name, "vehicle_brand");
                    await handleFetchModel(vehicleDetailsResponse?.data?.brand_name)
                    handleInput(vehicleDetailsResponse?.data?.variant_name, 'vehicle_variant')
                    handleInput(vehicleDetailsResponse?.data?.model_name, 'vehicle_model')
                    handleInput(vehicleDetailsResponse?.data?.insurance_date, 'insurance_validate_date')
                    await handleFetchVariant(vehicleDetailsResponse?.data?.model_name)
                    if(vehicleDetailsResponse?.data?.financer){
                        setCurrentHypo('Yes');
                        handleInput('Yes', 'current_hypothecation', '', 'meta_data', 'vehicle_details')
                        handleInput(vehicleDetailsResponse?.data?.financer, 'name_of_financier', '', 'meta_data', 'vehicle_details')
                    }
                }, 100)
            }
        } else if (
            vehicleDetailsResponse?.status !== 200
        ) {
            toast.warning(vehicleDetailsResponse?.message);
        }
    }, [vehicleDetailsResponse]);

    return (
        <>
            <Layout
                title={"Add New Case"}
                isLoading={isLoading}
                isGoback={true}
            >
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Case Type"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Vehicle Type'}
                                        data={[{id: "new_car", name: "New Car"}, {id: "used_car", name: "Used Car"}]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "vehicle_type");
                                        }}
                                        value={""}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>

                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Entity Type'}
                                        data={[{id: "Individual", name: "Individual"}, {
                                            id: "Company",
                                            name: "Company"
                                        }]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "entity_type");
                                        }}
                                        value={""}
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>


                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Co Applicant'}
                                        data={[{id: "Yes", name: "Yes"}, {
                                            id: "No",
                                            name: "No"
                                        }]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "co_applicant");
                                        }}
                                        value={""}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

                {inputList[0]['entity_type'] === 'Individual' &&
                    <>
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">{"Customer Details"}</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Customer First Name"}
                                                handleChange={(val) =>
                                                    handleInput(
                                                        val,
                                                        "customer_first_name"
                                                    )
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Customer Last Name"}
                                                handleChange={(val) =>
                                                    handleInput(
                                                        val,
                                                        "customer_last_name"
                                                    )
                                                }
                                                value={""}
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Customer Mother Name"}
                                                handleChange={(val) =>
                                                    handleInput(
                                                        val,
                                                        "customer_mother_name"
                                                    )
                                                }
                                                value={""}
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Current Address"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'current_address', '', 'meta_data', 'customer_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Current Address Is'}
                                                data={[{
                                                    id: "My Own House",
                                                    name: "My Own House"
                                                }, {id: "Rented Property", name: "Rented Property"}]}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'current_address_is', '', 'meta_data', 'customer_details')
                                                }}
                                                value={""}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Mobile No"}
                                                handleChange={(val) => {
                                                    handleInput(val, "mobile_no");
                                                }
                                                }
                                                value={inputList[0]['mobile_no']}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                maxLength={10}
                                                minLength={10}
                                                checkDigits={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Email"}
                                                handleChange={(val) =>
                                                    handleInput(
                                                        val,
                                                        "email"
                                                    )
                                                }
                                                value={""}
                                                type="email"
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Date of Birth"}
                                                handleChange={(val) =>
                                                    handleInput(
                                                        val,
                                                        "dob"
                                                    )
                                                }
                                                value={""}
                                                type="date"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Gender'}
                                                data={[{id: "Male", name: "Male"}, {id: "Female", name: "Female"}, {
                                                    id: "Other",
                                                    name: "Other"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, "gender");
                                                }}
                                                value={""}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Aadhar Card"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'adhaar_card', '', 'meta_data', 'customer_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                checkDigits={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Pan No"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'pan_no', '', 'meta_data', 'customer_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                maxLength={10}
                                                minLength={10}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Education Qualification'}
                                                data={[{
                                                    id: "Secondary",
                                                    name: "Secondary"
                                                }, {
                                                    id: "Higher Secondary",
                                                    name: "Higher Secondary"
                                                }, {
                                                    id: "Graduation",
                                                    name: "Graduation"
                                                }, {
                                                    id: "Post Graduation",
                                                    name: "Post Graduation"
                                                }, {
                                                    id: "Doctorate",
                                                    name: "Doctorate"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'education', '', 'meta_data', 'customer_details')
                                                }}
                                                value={""}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        {inputList[0]['entity_type'] === 'Individual' && inputList[0]['co_applicant'] === 'No' &&
                                            <>
                                                <div className="col-sm-4">
                                                    <ConstantInput
                                                        label={"Account Number"}
                                                        handleChange={(val) =>
                                                            handleInput(val, 'account_no', '', 'meta_data', 'customer_details')
                                                        }
                                                        value={""}
                                                        type="text"
                                                        checkDigits={true}
                                                    />
                                                </div>
                                                <div className="col-sm-4">
                                                    <DropDownInput
                                                        label={'Bank Name'}
                                                        data={newBankDetailsResponse}
                                                        getIdValue={(val) => {
                                                            handleInput(val.id, 'bank_name', '', 'meta_data', 'customer_details')
                                                        }}
                                                        value={""}
                                                    />
                                                </div>
                                                {inputList[0]['meta_data']['customer_details']['bank_name'] === 'Other' &&
                                                    <div className="col-sm-4">
                                                        <ConstantInput
                                                            label={"Bank Name"}
                                                            handleChange={(val) =>
                                                                setCustomerBankName(val)
                                                            }
                                                            value={""}
                                                            type="text"
                                                        />
                                                    </div>
                                                }
                                                <div className="col-sm-4">
                                                    <ConstantInput
                                                        label={"IFSC Code"}
                                                        handleChange={(val) =>
                                                            handleInput(val, 'ifsc_code', '', 'meta_data', 'customer_details')
                                                        }
                                                        value={""}
                                                        type="text"
                                                        maxLength={11}
                                                        minLength={11}
                                                    />
                                                </div>
                                                <div className="col-sm-4">
                                                    <ConstantInput
                                                        label={"Branch Name"}
                                                        handleChange={(val) =>
                                                            handleInput(val, 'branch_name', '', 'meta_data', 'customer_details')
                                                        }
                                                        value={""}
                                                        type="text"
                                                    />
                                                </div>
                                            </>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {(inputList[0]['entity_type'] === 'Company' || inputList[0]['co_applicant'] === 'Yes') &&
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">{"Account Holder"}</div>
                            <div className="card-body">
                                <div className="row">
                                    {accountHolder.map((val, i) => (
                                        <div key={i} className="container-fluid">
                                            <div className="card">
                                                <div className="card-header">{`Holder ${i + 1}`}</div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        {inputList[0]['entity_type'] === 'Individual' && inputList[0]['co_applicant'] === 'Yes' && (
                                                            <div className="col-sm-4">
                                                                <DropDownInput
                                                                    label={'Select account holder'}
                                                                    data={[
                                                                        {
                                                                            id: "Primary",
                                                                            name: "Primary Customer"
                                                                        },
                                                                        {id: "Co_Applicant", name: "Co-Applicant"}
                                                                    ]}
                                                                    getIdValue={(val) => handleAccountHolderInput(val.id, "account_holder", i)}
                                                                    value={val.account_holder}
                                                                />
                                                            </div>
                                                        )}

                                                        {inputList[0]['entity_type'] === 'Company' && inputList[0]['co_applicant'] === 'Yes' && (
                                                            <div className="col-sm-4">
                                                                <DropDownInput
                                                                    label={'Select account holder'}
                                                                    data={[
                                                                        {id: "Primary", name: "Company"},
                                                                        {id: "Co-Applicant", name: "Co-Applicant"}
                                                                    ]}
                                                                    getIdValue={(val) => handleAccountHolderInput(val.id, "account_holder", i)}
                                                                    value={val.account_holder}
                                                                />
                                                            </div>
                                                        )}

                                                        <div className="col-sm-4">
                                                            <ConstantInput
                                                                label={"Account Number"}
                                                                handleChange={(val) => handleAccountHolderInput(val, 'account_no', i)}
                                                                value={val.account_no}
                                                                type="text"
                                                                checkDigits={true}
                                                            />
                                                        </div>

                                                        <div className="col-sm-4">
                                                            <DropDownInput
                                                                label={'Bank Name'}
                                                                data={newBankDetailsResponse}
                                                                getIdValue={(val) => handleAccountHolderInput(val.id, 'bank_name', i)}
                                                                value={val.bank_name}
                                                            />
                                                        </div>

                                                        {val?.bank_name === 'Other' &&
                                                            <div className="col-sm-4">
                                                                <ConstantInput
                                                                    label={'Bank Name'}
                                                                    handleChange={(val) => handleAccountHolderInput(val, 'other_bank', i)}
                                                                    value={val.ifsc_code}
                                                                    type="text"
                                                                />
                                                            </div>
                                                        }
                                                        <div className="col-sm-4">
                                                            <ConstantInput
                                                                label={"IFSC Code"}
                                                                handleChange={(val) => handleAccountHolderInput(val, 'ifsc_code', i)}
                                                                value={val.ifsc_code}
                                                                type="text"
                                                                maxLength={11}
                                                                minLength={11}
                                                            />
                                                        </div>

                                                        <div className="col-sm-4">
                                                            <ConstantInput
                                                                label={"Branch Name"}
                                                                handleChange={(val) => handleAccountHolderInput(val, 'branch_name', i)}
                                                                value={val.branch_name}
                                                                type="text"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="btn-box mb-4" style={{width: "100%"}}>
                                                {accountHolder.length > 1 && (
                                                    <button
                                                        onClick={(e) => handleRemoveAccountHolder(e, i)}
                                                        className="btn btn-sm btn-danger ml-3">
                                                        - Remove Account Holder
                                                    </button>
                                                )}
                                                {accountHolder.length - 1 === i && accountHolder.length <= 1 && (
                                                    <button
                                                        className="btn btn-sm btn-primary ml-3 mt-3"
                                                        onClick={handleAddAccountHolder}>
                                                        + Add Account Holder
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }


                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Employee Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Employee Type'}
                                        data={[{id: "Salaried", name: "Salaried"}, {
                                            id: "Self Employed",
                                            name: "Self Employed"
                                        }]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "employee_type");
                                        }}
                                        value={""}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Occupation"}
                                        handleChange={(e) =>
                                            handleInput(e, 'occupation', '', 'meta_data', 'employee_details')
                                        }
                                        value={""}
                                        type="text"
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Annual Income"}
                                        handleChange={(e) =>
                                            handleInput(e, 'annual_income', '', 'meta_data', 'employee_details')
                                        }
                                        value={""}
                                        type="number"
                                        required={true}
                                        isStarRequired={true}
                                        decimal={'decimal'}
                                        step={'any'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Vehicle Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 d-flex">
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Vehicle Registration No"}
                                            handleChange={(val) => {
                                                handleInput(
                                                    val,
                                                    "vehicle_no"
                                                )
                                                setVehicleNo(val)
                                            }
                                            }
                                            value={inputList[0]['vehicle_no']}
                                            // disabled={true}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    <div className="col-2 mt-2">
                                        <a className="btn btn-outline-primary btn-primary colorBox borderColorBox"
                                           onClick={(e) => {
                                               handleSearch(e)
                                           }}>🔍</a>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Vehicle Brand'}
                                        data={carBrandResponse}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "vehicle_brand");
                                            handleInput('', "vehicle_model");
                                            handleInput('', "vehicle_variant");
                                            handleFetchModel(val.id)
                                        }}
                                        value={inputList[0]['vehicle_brand']}
                                        // disabled={true}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Vehicle Model'}
                                        data={carModelResponse}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "vehicle_model");
                                            handleFetchVariant(val.id)
                                        }}
                                        value={inputList[0]['vehicle_model']}
                                        // disabled={true}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Vehicle variant'}
                                        data={carVariantResponse}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "vehicle_variant");
                                        }}
                                        value={inputList[0]['vehicle_variant']}
                                        // disabled={true}
                                        // isStarRequired={true}
                                    />
                                </div>
                                {/*<div className="col-sm-4">*/}
                                {/*    <ConstantInput*/}
                                {/*        label={"Year of Manufacturing"}*/}
                                {/*        handleChange={(val) =>*/}
                                {/*            handleInput(*/}
                                {/*                val,*/}
                                {/*                "year_of_manufacturing"*/}
                                {/*            )*/}
                                {/*        }*/}
                                {/*        value={""}*/}
                                {/*        type="date"*/}
                                {/*        required={true}*/}
                                {/*        isStarRequired={true}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={"Year of Manufacturing"}
                                        data={manufaturingDate.length > 0 ? manufaturingDate : []}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "year_of_manufacturing");
                                        }}
                                        value={inputList[0]['year_of_manufacturing']}
                                        // disabled={true}
                                        // isStarRequired={true}
                                        // required={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Active Insurance'}
                                        data={[{id: "Yes", name: "Yes"}, {id: "No", name: "No"}]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, "active_insurance");
                                        }}
                                        value={inputList[0]['active_insurance']}
                                        // disabled={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Insurance Validate"}
                                        handleChange={(val) =>
                                            handleInput(
                                                val,
                                                "insurance_validate_date"
                                            )
                                        }
                                        value={inputList[0]['insurance_validate_date']}
                                        // disabled={true}
                                        type="date"
                                        // required={inputList[0]?.active_insurance === 'Yes'}
                                        // isStarRequired={inputList[0]?.active_insurance === 'Yes'}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Engine Number"}
                                        handleChange={(val) =>
                                            handleInput(val, 'engine_no', '', 'meta_data', 'vehicle_details')
                                        }
                                        value={inputList[0]['meta_data']?.vehicle_details?.engine_no}
                                        // disabled={true}
                                        type="text"
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Chassis Number"}
                                        handleChange={(val) =>
                                            handleInput(val, 'chassis_no', '', 'meta_data', 'vehicle_details')
                                        }
                                        value={inputList[0]['meta_data']?.vehicle_details?.chassis_no}
                                        // disabled={true}
                                        type="text"
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={'Ownership series'}
                                        handleChange={(val) =>
                                            handleInput(val, 'ownership_series', '', 'meta_data', 'vehicle_details')
                                        }
                                        value={inputList[0]['meta_data']?.vehicle_details?.ownership_series}
                                        // disabled={true}
                                        type="number"
                                        required={true}
                                        isStarRequired={true}
                                        decimal={'decimal'}
                                        step={'any'}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Transmission Type'}
                                        data={[{id: "Manual", name: "Manual"}, {
                                            id: "Automatic",
                                            name: "Automatic"
                                        }]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'transmission_type', '', 'meta_data', 'vehicle_details')
                                        }}
                                        value={inputList[0]['meta_data']?.vehicle_details?.transmission_type}
                                        // disabled={true}
                                        // isStarRequired={true}
                                        // required={true}
                                    />
                                </div>

                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Fuel Type'}
                                        data={[{id: "Petrol", name: "Petrol"}, {
                                            id: "CNG",
                                            name: "CNG"
                                        }, {id: "Petrol/CNG", name: "Petrol/CNG"},
                                            {id: "Diesel", name: "Diesel"},
                                            {id: "Hydrogen", name: "Hydrogen"},
                                            {id: "Electric", name: "Electric"},
                                            {id: "Hybrid", name: "Hybrid"}]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'fuel_type', '', 'meta_data', 'vehicle_details')
                                        }}
                                        value={inputList[0]['meta_data']?.vehicle_details?.fuel_type}
                                        // disabled={true}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Insurance Provider"}
                                        handleChange={(val) => {
                                            handleInput(val, 'insurance_provider', '', 'meta_data', 'vehicle_details')

                                        }
                                        }
                                        value={inputList[0]['meta_data']?.vehicle_details?.insurance_provider}
                                        // disabled={true}
                                        type="text"
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Current Hypothecation'}
                                        data={[{id: "Yes", name: "Yes"}, {
                                            id: "No",
                                            name: "No"
                                        }]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'current_hypothecation', '', 'meta_data', 'vehicle_details')
                                            setCurrentHypo(val.id)
                                        }}
                                        value={inputList[0]['meta_data']?.vehicle_details?.current_hypothecation}
                                        // disabled={true}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>
                                {currentHypo === 'Yes' &&
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Name of Financier"}
                                            handleChange={(val) => {
                                                handleInput(val, 'name_of_financier', '', 'meta_data', 'vehicle_details')
                                            }}
                                            value={inputList[0]['meta_data']?.vehicle_details?.name_of_financier}
                                            // disabled={true}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {inputList[0]['vehicle_type'] === 'used_car' &&
                    <>
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">{"Loan Details"}</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Bank Name'}
                                                data={bankListResponse}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, "bank_name");
                                                }}
                                                value={""}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>

                                        {inputList[0]['bank_name'] === "Other" &&
                                            <div className="col-sm-4">
                                                <ConstantInput
                                                    label={"Bank Name"}
                                                    handleChange={(val) =>
                                                        setBankName(val)
                                                    }
                                                    value={""}
                                                    type="text"
                                                    required={true}
                                                    isStarRequired={true}
                                                />
                                            </div>
                                        }
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Loan Approved Amount"}
                                                handleChange={(val) =>
                                                    handleInput(
                                                        val,
                                                        "loan_approved_amount"
                                                    )
                                                }
                                                value={""}
                                                type="number"
                                                decimal={'decimal'}
                                                step={'any'}
                                                // required={true}
                                                // isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Net disbursal amount"}
                                                handleChange={(val) =>
                                                    handleInput(
                                                        val,
                                                        "loan_required_amount"
                                                    )
                                                }
                                                value={""}
                                                type="number"
                                                required={true}
                                                isStarRequired={true}
                                                decimal={'decimal'}
                                                step={'any'}
                                            />
                                        </div>

                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Tenure(Months)"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'tenure', '', 'meta_data', 'loan_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                checkDigits={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Rate of Interest"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'rate_of_interest', '', 'meta_data', 'loan_details')
                                                }
                                                value={""}
                                                type="number"
                                                required={true}
                                                isStarRequired={true}
                                                decimal={'decimal'}
                                                step={'any'}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Loan Type'}
                                                data={[{
                                                    id: "External BT-Topup ",
                                                    name: "External BT-Topup "
                                                }, {id: "Internal Topup", name: "Internal Topup"},
                                                    {id: "Internal BT", name: "Internal BT"}, {
                                                        id: "Purchase",
                                                        name: "Purchase"
                                                    },
                                                    {id: "Refinance", name: "Refinance"}]}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'loan_type', '', 'meta_data', 'loan_details')
                                                }}
                                                value={""}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>

                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Is Processing Fees Required'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleChargesInput('processing_fees', val.id)
                                                }}
                                                value={isChargesRequired[0].processing_fees}
                                                // disabled={true}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>
                                        {isChargesRequired[0]?.processing_fees === 'Yes' &&
                                            <div className="col-sm-4">
                                                <ConstantInput
                                                    label={"Processing Fees"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'processing_fees', '', 'meta_data', 'loan_details')
                                                    }
                                                    value={""}
                                                    type="number"
                                                    decimal={'decimal'}
                                                    step={'any'}
                                                />
                                            </div>
                                        }
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Is Loan Suraksha Required'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleChargesInput('loan_sursksha', val.id)
                                                }}
                                                value={isChargesRequired[0].loan_sursksha}
                                            />
                                        </div>
                                        {isChargesRequired[0]?.loan_sursksha === 'Yes' &&
                                            <div className="col-sm-4">
                                                <ConstantInput
                                                    label={"Loan Suraksha"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'loan_sursksha', '', 'meta_data', 'loan_details')
                                                    }
                                                    value={""}
                                                    type="number"
                                                    decimal={'decimal'}
                                                    step={'any'}
                                                />
                                            </div>
                                        }
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Is Valuation Charges Required'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleChargesInput('valuation_charge', val.id)
                                                }}
                                                value={isChargesRequired[0].valuation_charge}
                                            />
                                        </div>
                                        {isChargesRequired[0]?.valuation_charge === 'Yes' &&
                                            <div className="col-sm-4">
                                                <ConstantInput
                                                    label={"Valuation Charges"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'valuation_charge', '', 'meta_data', 'loan_details')
                                                    }
                                                    value={""}
                                                    type="number"
                                                    decimal={'decimal'}
                                                    step={'any'}
                                                />
                                            </div>
                                        }
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Is Documentation Charge Required'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleChargesInput('documentation_charge', val.id)
                                                }}
                                                value={isChargesRequired[0].documentation_charge}
                                            />
                                        </div>
                                        {isChargesRequired[0]?.documentation_charge === 'Yes' &&
                                            <div className="col-sm-4">
                                                <ConstantInput
                                                    label={"Documentation Charge"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'documentation_charge', '', 'meta_data', 'loan_details')
                                                    }
                                                    value={""}
                                                    type="number"
                                                    decimal={'decimal'}
                                                    step={'any'}
                                                />
                                            </div>
                                        }
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Is Stamp Charge Required'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleChargesInput('stamp_charge', val.id)
                                                }}
                                                value={isChargesRequired[0].stamp_charge}
                                            />
                                        </div>
                                        {isChargesRequired[0]?.stamp_charge === 'Yes' &&
                                            <div className="col-sm-4">
                                                <ConstantInput
                                                    label={"Stamp Charge"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'stamp_charge', '', 'meta_data', 'loan_details')
                                                    }
                                                    value={""}
                                                    type="number"
                                                    decimal={'decimal'}
                                                    step={'any'}
                                                />
                                            </div>
                                        }
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Is Other Charges Required'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleChargesInput('other_charges', val.id)
                                                }}
                                                value={isChargesRequired[0].other_charges}
                                            />
                                        </div>
                                        {/*<div className="col-sm-4">*/}
                                        {/*    <ConstantInput*/}
                                        {/*        label={"Disbursal Date"}*/}
                                        {/*        handleChange={(val) =>*/}
                                        {/*            handleInput(val, 'disbursal_date', 'meta_data', 'loan_details')*/}
                                        {/*        }*/}
                                        {/*        value={""}*/}
                                        {/*        type="date"*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        {isChargesRequired[0]?.other_charges === 'Yes' &&
                                            <div className="col-sm-4">
                                                <ConstantInput
                                                    label={"Other Charges"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'other_charges', '', 'meta_data', 'loan_details')
                                                    }
                                                    value={""}
                                                    type="number"
                                                    decimal={'decimal'}
                                                    step={'any'}
                                                />
                                            </div>
                                        }

                                        {/*<div className="col-sm-4">*/}
                                        {/*    <ConstantInput*/}
                                        {/*        label={"Disbursal Date"}*/}
                                        {/*        handleChange={(val) =>*/}
                                        {/*            handleInput(val, 'disbursal_date', '', 'meta_data', 'loan_details')*/}
                                        {/*        }*/}
                                        {/*        value={""}*/}
                                        {/*        type="date"*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        {/*<div className="col-sm-4">*/}
                                        {/*    <ConstantInput*/}
                                        {/*        label={"Car Value"}*/}
                                        {/*        handleChange={(val) =>*/}
                                        {/*            handleInput(*/}
                                        {/*                val,*/}
                                        {/*                "car_value"*/}
                                        {/*            )*/}
                                        {/*        }*/}
                                        {/*        value={""}*/}
                                        {/*        type="text"*/}
                                        {/*        required={true}*/}
                                        {/*        isStarRequired={true}*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {(inputList[0]['entity_type'] === 'Company') &&
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">{"Company Details"}</div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Company Name"}
                                            handleChange={(val) => {
                                                handleInput(val, 'company_name', '', 'meta_data', 'company_details');
                                                setCompanyName(val)
                                            }
                                            }
                                            value={""}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <DropDownInput
                                            label={'Company Type'}
                                            data={[{
                                                id: "Pvt Ltd",
                                                name: "Pvt Ltd"
                                            }, {id: "HUF", name: "HUF"},
                                                {id: "Sole Proprietor", name: "Sole Proprietor"}, {
                                                    id: "Partnership Firm",
                                                    name: "Partnership Firm"
                                                }]}
                                            getIdValue={(val) => {
                                                handleInput(val.id, 'company_type', '', 'meta_data', 'company_details')
                                            }}
                                            value={""}
                                            isStarRequired={true}
                                            required={true}
                                        />
                                    </div>
                                    {parseInt(userId) !== 876 &&
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Co Application Relation"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'co_application_relation', 'meta_data', 'company_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                    }

                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Company PAN"}
                                            handleChange={(val) =>
                                                handleInput(val, 'company_pan', '', 'meta_data', 'company_details')
                                            }
                                            value={""}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                            maxlength={10}
                                            minlength={10}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Company GST"}
                                            handleChange={(val) =>
                                                handleInput(val, 'company_gst', '', 'meta_data', 'company_details')
                                            }
                                            value={""}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                            maxlength={15}
                                            minlength={15}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"ESTD in (Year)"}
                                            handleChange={(val) =>
                                                handleInput(val, 'estd_year', '', 'meta_data', 'company_details')
                                            }
                                            value={""}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Registered Company Email"}
                                            handleChange={(val) =>
                                                handleInput(val, 'email', '', 'meta_data', 'company_details')
                                            }
                                            value={""}
                                            type="text"
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Address"}
                                            handleChange={(val) =>
                                                handleInput(val, 'address', '', 'meta_data', 'company_details')
                                            }
                                            value={""}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Company Registered Phone Number"}
                                            handleChange={(val) =>
                                                handleInput(val, 'phone_no', '', 'meta_data', 'company_details')
                                            }
                                            value={""}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                            maxLength={10}
                                            minLength={10}
                                            checkDigits={true}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <ConstantInput
                                            label={"Same for permanent address"}
                                            handleChange={(val) =>
                                                handleInput(val, 'is_permanent_address', '', 'meta_data', 'company_details')
                                            }
                                            value={""}
                                            type="checkbox"
                                            required={true}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    {parseInt(userId) === 876 &&
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Company Turnover"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'company_turnover', 'meta_data', 'company_details')
                                                }
                                                value={""}
                                                type="number"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                }


                {(inputList[0]['entity_type'] === 'Company' || inputList[0]['co_applicant'] === 'Yes') &&
                    <>
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">{"Co-Applicant Details"}</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Co-Applicant First Name"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'applicant_first_name', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Co-Applicant Last Name"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'applicant_last_name', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="text"
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Relationship with Applicant"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'role', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Current Address"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'current_address', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Aadhar Card"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'adhaar_card', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                checkDigits={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Pan No"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'pan_no', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                maxLength={10}
                                                minLength={10}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Mobile No"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'mobile_no', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                maxLength={10}
                                                minLength={10}
                                                checkDigits={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Email"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'email', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="email"
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <ConstantInput
                                                label={"Date of Birth"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'dob', '', 'meta_data', 'applicant_details')
                                                }
                                                value={""}
                                                type="date"
                                                required={true}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Gender'}
                                                data={[{
                                                    id: "Male",
                                                    name: "Male"
                                                }, {id: "Female", name: "Female"},
                                                    {id: "Other", name: "Other"}]}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'gender', '', 'meta_data', 'applicant_details')
                                                }}
                                                value={""}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Education Qualification'}
                                                data={[{
                                                    id: "Secondary",
                                                    name: "Secondary"
                                                }, {
                                                    id: "Higher Secondary",
                                                    name: "Higher Secondary"
                                                }, {
                                                    id: "Graduation",
                                                    name: "Graduation"
                                                }, {
                                                    id: "Post Graduation",
                                                    name: "Post Graduation"
                                                }, {
                                                    id: "Doctorate",
                                                    name: "Doctorate"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleInput(val?.id, 'education', '', 'meta_data', 'applicant_details')
                                                }}
                                                value={""}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"RC Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Original RC available'}
                                        data={[{
                                            id: "Yes",
                                            name: "Yes"
                                        }, {
                                            id: "No",
                                            name: "No"
                                        }]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'is_rc_available', '', 'meta_data', 'additional_details')
                                        }}
                                        value={inputList[0]['meta_data']?.addition_details?.is_rc_available}
                                    />
                                </div>
                                {inputList[0]['meta_data']['additional_details']?.is_rc_available && inputList[0]['meta_data']['additional_details']?.is_rc_available === 'No' &&
                                    <>
                                        <div className="col-md-3 col-sm-12">
                                            <FileUpload
                                                id={"form_26"}
                                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(val) => handleInput(val, 'form_26', '', 'meta_data', 'additional_details')}
                                                prefilledFilename={inputList[0]['meta_data']?.additional_details?.form_26 ? "FORM26" : ""}
                                                width={"100%"}
                                            >
                                        <span className="btn btn-transparent"
                                              style={{minWidth: '100%'}}>FORM26</span>
                                            </FileUpload>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <FileUpload
                                                id={"bh_approval"}
                                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(val) => handleInput(val, 'bh_approval', '', 'additional_details')}
                                                prefilledFilename={inputList[0]['meta_data']?.additional_details?.bh_approval ? "BH Approval" : ""}
                                                width={"100%"}
                                            >
                                        <span className="btn btn-transparent"
                                              style={{minWidth: '100%'}}>BH Approval</span>
                                            </FileUpload>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <FileUpload
                                                id={"FIR"}
                                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(val) => handleInput(val, 'fir', '', 'meta_data', 'additional_details')}
                                                prefilledFilename={inputList[0]['meta_data']?.additional_details?.fir ? "FIR" : ""}
                                                width={"100%"}
                                            >
                                        <span className="btn btn-transparent"
                                              style={{minWidth: '100%'}}>FIR</span>
                                            </FileUpload>
                                        </div>
                                    </>
                                }
                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'RC Transfer by'}
                                        data={[{
                                            id: "Park+",
                                            name: "Park+"
                                        }, {
                                            id: "Dealer",
                                            name: "Dealer"
                                        }]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'rc_transfer_by', '', 'meta_data', 'additional_details')
                                        }}
                                        value={inputList[0]['meta_data']?.additional_details?.is_rc_available}
                                    />
                                </div>

                                {inputList[0]['meta_data']['additional_details']?.rc_transfer_by && inputList[0]['meta_data']['additional_details']?.rc_transfer_by === 'Dealer' &&
                                    <div className="col-md-3 col-sm-12">
                                        <FileUpload
                                            id={"undertaking"}
                                            accept=".pdf,.png,.jpg,.jpeg,.doc"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => handleInput(val, 'undertaking', '', 'meta_data', 'additional_details')}
                                            prefilledFilename={inputList[0]['meta_data']?.additional_details?.undertaking ? "Undertaking" : ""}
                                            width={"100%"}
                                        >
                                        <span className="btn btn-transparent"
                                              style={{minWidth: '100%'}}>Undertaking</span>
                                        </FileUpload>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Addition Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                {/*<div className="col-sm-4">*/}
                                {/*    <ConstantInput*/}
                                {/*        label={"RTO Charges"}*/}
                                {/*        handleChange={(e) =>*/}
                                {/*            handleInput(e, 'rto_charges', '', 'meta_data', 'additional_details')*/}
                                {/*        }*/}
                                {/*        value={""}*/}
                                {/*        type="number"*/}
                                {/*        step="any"*/}
                                {/*        inputMode="decimal"*/}
                                {/*    />*/}
                                {/*</div>*/}
                                {/*<div className="col-md-3 col-sm-12">*/}
                                {/*    <FileUpload*/}
                                {/*        id={"rto_receipt"}*/}
                                {/*        accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*        documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*        documentUrlData={documentUrlDataPublic}*/}
                                {/*        onChange={(val) => handleInput(val, 'rto_receipt', '', 'meta_data', 'additional_details')}*/}
                                {/*        prefilledFilename={inputList[0]['meta_data']['additional_details']['rto_receipt'] ? "RTO Receipt" : ""}*/}
                                {/*        width={"100%"}*/}
                                {/*    >*/}
                                {/*    <span className="btn btn-transparent"*/}
                                {/*          style={{minWidth: '100%'}}>RTO Receipt</span>*/}
                                {/*    </FileUpload>*/}
                                {/*</div>*/}
                                {/*<div className="col-sm-4">*/}
                                {/*    <ConstantInput*/}
                                {/*        label={"Challan Charges"}*/}
                                {/*        handleChange={(e) =>*/}
                                {/*            handleInput(e, 'challan_charges', '', 'meta_data', 'additional_details')*/}
                                {/*        }*/}
                                {/*        value={""}*/}
                                {/*        type="number"*/}
                                {/*        step="any"      // Allows decimal input*/}
                                {/*        inputMode="decimal"*/}
                                {/*    />*/}
                                {/*</div>*/}
                                {/*<div className="col-md-3 col-sm-12">*/}
                                {/*    <FileUpload*/}
                                {/*        id={"challan_receipt"}*/}
                                {/*        accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*        documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*        documentUrlData={documentUrlDataPublic}*/}
                                {/*        onChange={(val) => handleInput(val, 'challan_receipt', '', 'meta_data', 'additional_details')}*/}
                                {/*        prefilledFilename={inputList[0]['meta_data']['additional_details']['challan_receipt'] ? "Challan Receipt" : ""}*/}
                                {/*        width={"100%"}*/}
                                {/*    >*/}
                                {/*    <span className="btn btn-transparent"*/}
                                {/*          style={{minWidth: '100%'}}>Challan Receipt</span>*/}
                                {/*    </FileUpload>*/}
                                {/*</div>*/}
                                <div className="col-md-3 col-sm-12">
                                    <FileUpload
                                        id={"disbursal_memo"}
                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) => handleInput(val, 'disbursal_memo', '', 'meta_data', 'additional_details')}
                                        prefilledFilename={inputList[0]['meta_data']['additional_details']['disbursal_memo'] ? "Disbursal Memo" : ""}
                                        width={"100%"}
                                    >
                                                    <span className="btn btn-transparent"
                                                          style={{minWidth: '100%'}}>Disbursal Memo</span>
                                    </FileUpload>
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Disbursal Date"}
                                        handleChange={(val) =>
                                            handleInput(val, 'disbursal_date', 'meta_data', 'additional_details')
                                        }
                                        value={inputList[0]['meta_data']?.applicant_details?.disbursal_date}
                                        type="date"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Documents"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3 col-sm-12">
                                    <FileUpload
                                        id={"addPoAttachment"}
                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) => handleInput(val, 'rc')}
                                        prefilledFilename={inputList[0]['rc'] ? "RC" : ""}
                                        width={"100%"}
                                    >
                                                        <span className="btn btn-transparent"
                                                              style={{minWidth: '100%'}}>RC<div
                                                            style={{color: "red"}}>*</div></span>
                                    </FileUpload>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <FileUpload
                                        id={`pan_card`}
                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) => {
                                            handleInput(val, 'pan_card')
                                        }}
                                        required={true}
                                        prefilledFilename={inputList[0]['pan_card'] ? "Pan Card" : ""}
                                        width={"100%"}
                                    >
                                                        <span className="btn btn-transparent"
                                                              style={{minWidth: '100%'}}>Pan Card<div
                                                            style={{color: 'red'}}>*</div></span>

                                    </FileUpload>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <FileUpload
                                        id={`adhaar_card`}
                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) => {
                                            handleInput(val, 'adhaar_card')
                                        }}
                                        required={true}
                                        prefilledFilename={inputList[0]['adhaar_card'] ? "Adhaar Card" : ""}
                                        width={"100%"}
                                    >
                                                        <span className="btn btn-transparent"
                                                              style={{minWidth: '100%'}}>Adhaar Card<div
                                                            style={{color: "red"}}>*</div></span>

                                    </FileUpload>
                                </div>

                                {inputList[0]['employee_type'] === 'Salaried' ?
                                    <div className="col-md-3 col-sm-12">
                                        <FileUpload
                                            id={`salary_slip`}
                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => {
                                                handleInput(val, 'salary_slip')
                                            }}
                                            required={true}
                                            prefilledFilename={inputList[0]['salary_slip'] ? "Salary Slip" : ""}
                                            width={"100%"}
                                            multiple={true}
                                        >
                                                            <span className="btn btn-transparent"
                                                                  style={{minWidth: '100%'}}>Salary Slip(Last 3 Months)</span>

                                        </FileUpload>
                                    </div> :
                                    <div className="col-md-3 col-sm-12">
                                        <FileUpload
                                            id={`itr`}
                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => {
                                                handleInput(val, 'itr')
                                            }}
                                            required={true}
                                            prefilledFilename={inputList[0]['itr'] ? "ITR" : ""}
                                            width={"100%"}
                                            multiple={true}
                                        >
                                                            <span className="btn btn-transparent"
                                                                  style={{minWidth: '100%'}}>ITR(Last 2 Years)</span>

                                        </FileUpload>
                                    </div>
                                }
                                <div className="col-md-3 col-sm-12">
                                    <FileUpload
                                        id={`rent_agreement`}
                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) => {
                                            handleInput(val, 'rent_agreement')
                                        }}
                                        prefilledFilename={inputList[0]['rent_agreement'] ? "Rent Agreement" : ""}
                                        width={"100%"}
                                    >
                                        <span className="btn btn-transparent"
                                              style={{minWidth: '100%'}}>
                                        Rent Agreement
                                        </span>
                                    </FileUpload>
                                </div>
                                {inputList[0]['employee_type'] === 'Self Employed' &&
                                    <div className="col-md-3 col-sm-12">
                                        <FileUpload
                                            id={`business_proof`}
                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => {
                                                handleInput(val, 'business_proof')
                                            }}
                                            prefilledFilename={inputList[0]['business_proof'] ? "Business proof (GST/MSME)" : ""}
                                            width={"100%"}
                                        >
                                            <span className="btn btn-transparent"
                                                  style={{minWidth: '100%'}}>
                                            Business proof (GST/MSME)
                                            </span>
                                        </FileUpload>
                                    </div>
                                }

                                {inputList[0]['employee_type'] === 'Self Employed' &&
                                    <div className="col-md-3 col-sm-12">
                                        <FileUpload
                                            id={`electricity_bill`}
                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => {
                                                handleInput(val, 'electricity_bill')
                                            }}
                                            prefilledFilename={inputList[0]['electricity_bill'] ? "Electricity Bill" : ""}
                                            width={"100%"}
                                        >
                                            <span className="btn btn-transparent"
                                                  style={{minWidth: '100%'}}>
                                            Electricity Bill
                                            </span>
                                        </FileUpload>
                                    </div>
                                }
                                <div className="col-md-3 col-sm-12">
                                    <FileUpload
                                        id={`bank_statement`}
                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(val) => {
                                            handleInput(val, 'bank_statement')
                                        }}
                                        required={true}
                                        prefilledFilename={inputList[0]['bank_statement'] ? "Bank Statement" : ""}
                                        width={"100%"}
                                    >
                                                        <span className="btn btn-transparent"
                                                              style={{minWidth: '100%'}}>Bank Statement</span>

                                    </FileUpload>
                                </div>
                                {
                                    inputList[0]['active_insurance'] === 'Yes' &&
                                    <div className="col-md-3 col-sm-12">
                                        <FileUpload
                                            id={`insurance_certificate`}
                                            accept=".png,.jpg,.jpeg,.pdf,.doc"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => {
                                                handleInput(val, 'insurance_certificate')
                                            }}
                                            prefilledFilename={inputList[0]['insurance_certificate'] ? "Insurance Certificate" : ""}
                                            width={"100%"}
                                        >
                                                        <span className="btn btn-transparent"
                                                              style={{minWidth: '100%'}}>Insurance Certificate</span>

                                        </FileUpload>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Additional Documents"}</div>
                        <div className="card-body">
                            <div className="row">
                                {additionDocuments.map((val, i) => {
                                    return (
                                        <>
                                            <div className="d-flex col-md-12">
                                                <div className="col-md-2 col-sm-12">
                                                    <FileUpload
                                                        id={`addAttachment${i + 1}`}
                                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                        documentUploadUrl={documentUploadUrlPublic}
                                                        documentUrlData={documentUrlDataPublic}
                                                        onChange={(val) => {
                                                            handleAdditionInput(val, i)
                                                        }}
                                                        required={true}
                                                        prefilledFilename={additionDocuments[i]['doc'] ? `Document ${i + 1}` : ""}
                                                        width={"100%"}
                                                    >
                                                                        <span className="btn btn-transparent"
                                                                              style={{minWidth: '100%'}}>Document</span>

                                                    </FileUpload>
                                                </div>
                                                <div
                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                    {additionDocuments.length !== 1 &&
                                                        <button
                                                            onClick={(e) => handleRemoveDocuments(i)}
                                                            className="btn btn-sm btn-danger ml-3">Remove
                                                            Document
                                                        </button>
                                                    }
                                                    {additionDocuments.length === 1 &&
                                                        <button
                                                            className="btn btn-sm btn-primary ml-3"
                                                            onClick={(e) => handleAddDocuments()}>Add
                                                            Document
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                            {additionDocuments.length - 1 === i && i > 0 &&
                                                <button
                                                    className="btn btn-sm btn-primary ml-3"
                                                    onClick={(e) => handleAddDocuments()}>Add Document
                                                </button>
                                            }
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 mb-2">
                    <center>
                        <Button onClick={handleSubmit}>
                            Submit
                        </Button>
                    </center>
                </div>
            </Layout>
        </>
    );
};

export default SaveDealerCase;
